import React from 'react'

const RecentUpdateCard = ({ hasDate=false, content='' }) => {
  return (
    <div className='msync-recent-update'>
        <span className='recent-update-date'>{hasDate}</span>
        <p className='recent-update-content'>{content}</p>
    </div>
  )
}

export default RecentUpdateCard